var FcMaintenanceTypesInputModule = /** @class */ (function () {
    function FcMaintenanceTypesInputModule() {
    }
    return FcMaintenanceTypesInputModule;
}());
export { FcMaintenanceTypesInputModule };
